import React from 'react';
import { useTranslation } from 'react-i18next';
import { classnames } from '../../../../utils/classnames';
import ItemCardActions from './components/itemCardActions/itemCardActions';
import { Status } from '../../../ui/index';
import './itemCard.css';

export function CustomChildrenitemCard({children}) {
    return (
        <div>
            <div className='neo-item-card-infos-separator'/>
            {children}
        </div>
    )
}

export default function ItemCard({status = null, type = 'item-card', title = null, subtitle = null, action = null, children }) {
    const { t } = useTranslation();
    const [showMore, setShowMore] = React.useState(false);

    const color = React.useMemo(() => {
        switch(status) {
            case 'ongoing':
            case 'valid': // ticket status
                return 'green';
            case 'pending':
            case 'reserved': // ticket status
                return 'orange';
            case 'waiting_confirmation':
            case 'removed': // ticket status
                return 'red';
            case 'used':
            case 'expired':
            case 'canceled':
                return 'grey'
            default:
                return ''
        }
    }, [status]);

    const _infosAction = React.useMemo(() => {
        if (children) {
            return {
                label: t('widget.item-card.informations'),
                icon: "infoCircle",
                onClick: () => setShowMore(state => !state)
            }
        }
        return null;
    }, [children]);

    const _onClick = React.useMemo(() => {      
        return action?.enabled ? action.onClick : null;
    }, [action]);

    return (
        <div className={classnames('neo-item-card-container', {clickable: action})} onClick={_onClick}>
            <div className={classnames('neo-item-card')}>
                <div className='neo-item-card-left-container'>
                    <div className={classnames('neo-item-card-status-line', color)} />
                    <div>
                        <div className='neo-item-card-title'>{title}</div>
                        <div className='neo-item-card-subtitle'>{subtitle}</div>
                        {status && <Status color={color} text={t(`widget.${type}.status.${status}`)}/>}
                    </div>
                </div>
                <div className='neo-item-card-right-container'>
                    <ItemCardActions mainAction={action} infosAction={_infosAction}/>
                </div>
            </div>
            {showMore && <CustomChildrenitemCard>{children}</CustomChildrenitemCard>}
        </div>
    )
}